import Button from 'antd/es/button';
import Card from 'antd/es/card';
import styled, { css } from 'styled-components';

export const FlatButton = styled(Button)`
  box-shadow: none !important;
  &:hover,
  &:focus,
  &:active {
    box-shadow: none !important;
  }
`;

export const PageContainer = styled.div<{ $fullScreen?: boolean }>`
  ${({ theme, $fullScreen }) => css`
    padding: ${theme.paddingLG}px;
    max-width: ${$fullScreen ? '100%' : '1200px'};
    margin: 0 auto;
    transition: all ${theme.motionDurationMid} ease;
    width: ${$fullScreen ? '100%' : 'auto'};
    box-sizing: border-box;
    position: relative;
  `}
`;

export const TwoColumnLayout = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: ${theme.marginLG}px;
    align-items: start;
    transition: gap ${theme.motionDurationMid} ${theme.motionEaseInOut};
  `}

  /* will only show one column on mobile or smaller screens (like stripe) */
  @media (max-width: ${({ theme }) => theme.screenXS}px) {
    grid-template-columns: 1fr;
  }

  /* Fullscreen mode - use more space */
  .fullscreen & {
    gap: ${({ theme }) => theme.marginLG}px;
  }
`;

export const Section = styled(Card)`
  margin-bottom: ${({ theme }) => theme.marginLG}px;
  &.ant-card {
    border: none;
    background: none;
  }
`;

export const DetailRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.paddingXS}px 0;
    border-bottom: ${theme.lineWidth}px ${theme.lineType}
      ${theme.colorBorderSecondary};
  `}

  &:last-child {
    border-bottom: none;
  }
`;

export const VersionHistoryButton = styled(FlatButton)`
  ${({ theme }) => css`
    outline: none;
    border: none;
    transition: all ${theme.motionDurationMid} ease;

    &:hover {
      background-color: ${theme.colorBgTextHover} !important;
    }
  `}
`;
